import {Rect} from "./Rect";
import {Vector2} from "./Vector2";

export var geometries = {
    Rect,
    Vector2,
};